<div 
  *ngIf="!isWordmark"
  class="outline"
  [ngStyle]="titleStyles | theme"
>
  {{ title }}
</div>

<img 
  *ngIf="isWordmark"
  [src]="wordmarkUrl" 
  alt="Solitaire Wordmark"
  class="game-wordmark"
/>